import * as React from 'react';
import { useFromScreens } from '@doltech/ui/lib/hooks/useDeviceQuery.hook';
import {
  GrammarLandingAuthorPageMobile,
} from './GrammarLandingAuthorPageMobile';
import {
  GrammarLandingAuthorPageDesktop,
} from './GrammarLandingAuthorPageDesktop';

interface GrammarLandingAuthorPageProps {
  urlInfo?: {
    seoPageAuthor?: any;
    name?: string;
  };
  data?: any;
  otherUrlInfo?: any;
  isLoggedIn?: any;
}

export const GrammarLandingAuthorPage = (props: GrammarLandingAuthorPageProps) => {
  const [, from1024] = useFromScreens([0, 1024]);

  if (from1024) {
    return <GrammarLandingAuthorPageDesktop {...props}/>;
  }

  return (
    <GrammarLandingAuthorPageMobile {...props}/>
  );
};
